import MoreVertIcon from '@mui/icons-material/MoreVert';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Box, IconButton, Menu, MenuItem, Stack, Tooltip, Typography } from '@mui/material';
import { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import type { Protocolo } from '../types';

import { EstadoBadge } from './EstadoBadge';

interface ProtocoloDetailHeaderProps {
  protocolo: Protocolo;
  canManage: boolean;
  onEliminar: () => void;
}

export function ProtocoloDetailHeader({
  protocolo,
  canManage,
  onEliminar,
}: ProtocoloDetailHeaderProps): JSX.Element {
  const navigate = useNavigate();
  const [menuAnchorEl, setMenuAnchorEl] = useState<null | HTMLElement>(null);
  const isClosed = protocolo.informe_final_emitido;

  function handleOpenMenu(e: React.MouseEvent<HTMLElement>): void {
    setMenuAnchorEl(e.currentTarget);
  }

  function handleCloseMenu(): void {
    setMenuAnchorEl(null);
  }

  function handleEliminar(): void {
    handleCloseMenu();
    onEliminar();
  }

  return (
    <Stack direction="row" alignItems="center" spacing={1.5} mb={3}>
      <IconButton
        size="small"
        aria-label="Volver al listado"
        onClick={() => navigate('/protocolos')}
      >
        <ArrowBackIcon />
      </IconButton>

      <Typography
        variant="h5"
        component="h1"
        fontWeight={600}
        sx={{ fontSize: { xs: '1.25rem', md: '1.5rem' }, minWidth: 0 }}
      >
        Protocolo N° {protocolo.numero_protocolo}
      </Typography>

      <EstadoBadge informeFinalEmitido={isClosed} />

      <Box sx={{ flex: 1 }} />

      {canManage && (
        <Box>
          <IconButton
            size="small"
            aria-label="Más acciones"
            onClick={handleOpenMenu}
          >
            <MoreVertIcon />
          </IconButton>
          <Menu
            anchorEl={menuAnchorEl}
            open={Boolean(menuAnchorEl)}
            onClose={handleCloseMenu}
          >
            <Tooltip
              title={isClosed ? 'No se puede eliminar un protocolo cerrado' : ''}
              placement="left"
            >
              <span>
                <MenuItem
                  onClick={handleEliminar}
                  disabled={isClosed}
                  sx={{ color: 'error.main' }}
                >
                  Eliminar protocolo
                </MenuItem>
              </span>
            </Tooltip>
          </Menu>
        </Box>
      )}
    </Stack>
  );
}
